import './Hero.css';
import dashboardImage from '../../assets/dashboard.png';

const Hero = () => {
  return (
    <section className="hero-section">
      <div className="container hero-container">
        <div className="hero-content">
          <span className="productivity-badge">Boost your productivity</span>
          <h1>Transform Your Business Operations with Optimiz</h1>
          <p>
            Seamlessly manage invoices, track employee performance, and empower
            your dealers—all in one powerful platform.
          </p>
          <div className="hero-buttons">
            <a href="/contact-us"  className="btn btn-primary btn-large">Start free trial</a>
          </div>
        </div>
      </div>

      {/* ✅ Dashboard Image Below */}
      <div className="hero-dashboard">
        <img src={dashboardImage} alt="Dashboard Preview" className="dashboard-img" />
      </div>
    </section>
  );
};

export default Hero;
